import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowUpRight, ArrowUp } from 'lucide-react';
import { COMPANY } from '../data/site';
import { FLOAT as FLOAT_IDS } from '../constants/testIds';

export default function FloatingCTAs() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Mobile floating buttons */}
      <div className="fixed bottom-4 left-4 right-4 z-40 flex md:hidden gap-3">
        <a
          href={`tel:${COMPANY.phoneTel}`}
          data-testid={FLOAT_IDS.call}
          className="flex-1 h-12 glass-strong border border-white/20 flex items-center justify-center gap-2 font-mono text-[11px] tracking-[0.22em] uppercase text-white"
        >
          <Phone size={14} strokeWidth={1.5} /> Appeler
        </a>
        <Link
          to="/contact"
          data-testid={FLOAT_IDS.quote}
          className="flex-1 h-12 bg-white text-black flex items-center justify-center gap-2 font-mono text-[11px] tracking-[0.22em] uppercase"
        >
          Devis <ArrowUpRight size={14} strokeWidth={1.5} />
        </Link>
      </div>

      {/* Desktop scroll-to-top */}
      {visible && (
        <button
          data-testid={FLOAT_IDS.toTop}
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Retour en haut"
          className="hidden md:inline-flex fixed bottom-6 right-6 z-40 h-11 w-11 items-center justify-center glass-strong border border-white/15 text-white hover:bg-white hover:text-black transition-colors"
        >
          <ArrowUp size={16} strokeWidth={1.5} />
        </button>
      )}
    </>
  );
}
